export default {
  mounted () {
    this.$store.commit('fieldRecordSystem/map/setShowDefaultLayers', false)
  },
  beforeDestroy () {
    this.$store.commit('fieldRecordSystem/map/setShowDefaultLayers', true)
  }
}
